<script setup lang="ts">
interface Props {
  submit_text?: string;
  disabled?: boolean;
}

defineProps<Props>();
const emit = defineEmits(["submit"]);
</script>

<template>
  <div class="w-full flex flex-col justify-center items-center relative gap-4">
    <button
      class="w-fit bg-famitei-green text-white rounded-lg px-8 py-4 hover:bg-green-800"
      :disabled="disabled"
      :class="{ 'opacity-50 cursor-not-allowed': disabled }"
      @click="emit('submit')"
    >
      {{ submit_text }}
    </button>
    <slot></slot>
  </div>
</template>
